import { GenericFormItem } from 'skyone-lib/lib/GenericForm/interfaces';
import i18n from 'i18n';

const fields: GenericFormItem[] = [
  {
    gridXs: 12,
    label: i18n.t('SALT.REASON_SALT_KEY'),
    stateKey: 'action_reason',
  },
];

export default fields;
